// extracted by mini-css-extract-plugin
export default {"tabProgress":"_1MBNZH4FcCElwgE-S9oexL","active":"_10bkBgSC-_jxfbQ2F3_uC5","stepCounter":"_3a_gr7xQ71stqEac49qn5z"};